<template>
  <div class="container-fluid" style="margin-top: 20px">
    <div class="row-fluid">
      <!--最新活动-->
      <div class="span12 text-left">
        <div class="cent" v-if="list == ''">暂未发布需求</div>
        <!-- <div class="jumbotron">
          <div class="container">
            <div class="row">
              <div class="col-2 middle">
                <img src="../../assets/logo.png" width="50" height="50" />
              </div>
              <div class="col-6">
                <div>
                  <h4>张帅</h4>
                </div>
                <div>523 积分</div>
              </div>
              <div class="col-4 text-right middle">
                <span class="label label-default">成为志愿者</span>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row-fluid" v-else>
          <div class="span12">
            <div
              class="jumbotron"
              v-for="(item, index) in list"
              :key="index"
              style="padding: 10px 15px"
              @click="route(item.id, index)"
            >
              <div class="row b_x tt_x_10" style="padding: 2px 0px 14px">
                <div class="col-9" style="padding-left: 10px">
                  <span class="label label-info">{{
                    item.community != 0 ? item.community : "暂无社区"
                  }}</span
                  >&nbsp; |
                  <span style="position: relative; top: 1px">{{
                    item.support_start_time ? item.support_start_time : ""
                  }}</span>
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 0"
                >
                  审核中
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 2"
                >
                  审核失败
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.support_community_pass == 3"
                >
                  审核中
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.state == 0 && item.support_community_pass == 1"
                >
                  发布中
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.state == 1 && item.support_community_pass == 1"
                >
                  等待接单
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.state == 2 && item.support_community_pass == 1"
                >
                  已接单
                </div>
                <div
                  class="col-3 text-right"
                  style="padding-left: 0"
                  v-if="item.state == 3 && item.support_community_pass == 1"
                >
                  完成结单
                </div>
              </div>
              <div class="row t_10">
                <div
                  class="col-12"
                  style="
                    line-height: 25px;
                    padding-right: 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item.assistance_text }}
                </div>
                <div class="row col-12" style="margin-top: 5px">
                  <div class="col-4" style="padding-right: 0">
                    <span class="glyphicon glyphicon-user"></span>
                    {{ item.username }}
                  </div>
                  <div class="col-8">{{ item.telephone }}</div>
                </div>
                <div class="col-12" style="height: 3px"></div>
                <div class="col-12 t_5 t_x_10">
                  <span class="glyphicon glyphicon-flag"></span>
                  {{ item.assistance_address.substring(6) }}
                </div>
                <div class="col-12" style="height: 3px"></div>
              </div>
              <div
                class="row b_t"
                style="margin-bottom: 0px"
                v-for="(i, j) in item.assistance_listjson"
                :key="j"
              >
                <div class="col-6 text-left" style="margin: 5px 0">
                  <h5>{{ i.title }}({{ i.value_amount }})</h5>
                </div>
                <div class="col-6 text-right" style="margin: 11px 0 5px">
                  <span class="label label-info"
                    >积分：{{ i.value_integral }}</span
                  >
                  <!-- <button type="button" class="btn btn-primary" v-if="i.value_a == 1">已接单</button>
              <button type="button" class="btn btn-primary" v-if="item.assistance_state == 2">完成结单</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="list != ''">
          <button
            v-if="moreShowBoolen"
            @click="moreShow1"
            class="btn_page btn1"
            style="
              display: block;
              margin: 25px auto 0;
              outline: none;
              color: #666;
              background-color: #eee;
              border-radius: 25px;
              height: 30px;
              width: 60%;
            "
          >
            更多选项
          </button>
          <div v-else style="text-align: center; margin-top: 15px">
            已无更多
          </div>
        </div>
        <div id="d_p"></div>
      </div>
    </div>
  </div>
</template>

<script>
import user_model from "../tool/user_model";
export default {
  name: "Loading",
  data() {
    return {
      list: [],
      nowPage: 1,
      moreShowBoolen: false,
      nowPage_t: 1,
    };
  },
  components: {},
  props: {},
  created() {},
  mounted() {
    this.moreShow1();
    // this.$api.getAPI("mutual/assistance/?appid=202108&type_id=3001&size=10&page=1", {
    //   openid: this.$api.getUserInfo().openid
    // }).then(res => {
    //   this.list = res.data.data.data[0].models
    //   this.aa(this.list)
    //   console.log(res.data.data.data[0].models);
    //   //社区名称
    //   this.$api.getAPI("build/app/202108?state=1").then(res => {
    //     // console.log(res.data.data.frame_users);
    //     for (let i = 0; i < this.list.length; i++) {
    //       for (let j = 0; j < res.data.data.frame_users.length; j++) {
    //         if (this.list[i].community == res.data.data.frame_users[j].id) {
    //           // console.log(123);
    //           this.list[i].community = res.data.data.frame_users[j].value
    //         }
    //       }
    //     }
    //     console.log(this.list);
    //   })
    // })
  },
  methods: {
    moreShow1() {
      // 点击查询更多
      //if(pageid)
      this.$api
        .getAPI("mutual/assistance/?appid=202108&type_id=3001&size=10", {
          page: this.nowPage,
          openid: this.$api.getUserInfo().openid,
        })
        .then((res) => {
          console.log(res);
          let ff = [];
          ff = res.data.data.data[0].models;
          this.aa(ff);
          for (let i = 0; i < ff.length; i++) {
            this.list.push(ff[i]);
          }
          this.$api.getAPI("build/app/202108?state=1").then((res) => {
            // console.log(res.data.data.frame_users);
            for (let i = 0; i < this.list.length; i++) {
              for (let j = 0; j < res.data.data.frame_users.length; j++) {
                if (this.list[i].community == res.data.data.frame_users[j].id) {
                  this.list[i].community = res.data.data.frame_users[j].value;
                }
              }
            }
          });
          var db = res.data.data.data[0];
          this.nowPage_t = db.page.count;
          this.moreShowBoolen = true;
          if (this.nowPage_t < this.nowPage * 10) {
            this.moreShowBoolen = false;
          }
          this.nowPage++;
        });
    },
    aa(list) {
      console.log(list);
      for (let i = 0; i < list.length; i++) {
        // console.log(list[i].support_start_time);
        if (list[i].support_start_time == "") {
        } else {
          var date = new Date(list[i].support_start_time * 1000);
          var Y = date.getFullYear() + "-";
          var M =
            (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + "-";
          var D = date.getDate() + " ";
          var h = date.getHours() + ":";
          var m = date.getMinutes() + ":";
          var s = date.getSeconds();
          list[i].support_start_time = Y + M + D + h + m + s;
          // console.log(list[i]);
        }
      }
      // console.log(list);
    },
    examine(id) {
      // console.log(id + '123');
      this.$router.push({
        name: "examine_show",
        query: {
          id: id,
        },
      });
    },
    route(id, index) {
      // console.log(id);
      console.log(this.list[index].state);
      if (this.list[index].state == 0) {
        if (this.list[index].support_community_pass == 2) {
          this.$router.push({
            name: "user_help_save",
            query: {
              id: id,
            },
          });
        } else if (this.list[index].assistance_listjson == null) {
          this.$router.push({
            name: "user_help_comment",
            query: {
              id: id,
            },
          });
        } else {
          this.$router.push({
            name: "user_help_save",
            query: {
              id: id,
            },
          });
        }
      } else if (this.list[index].state == 1) {
        this.$router.push({
          name: "user_help_comment",
          query: {
            id: id,
          },
        }); //显示接单人信息，没评价
      } else if (this.list[index].state == 2) {
        this.$router.push({
          name: "user_help_comment",
          query: {
            id: id,
          },
        }); //显示接单人信息，有评价,可以再传参
      }
    },
  },
};
</script>

<style>
.btn-primary {
  color: #fff;
  background-color: #01b2c2;
  border-color: #01b2c2;
}
.btn1 {
  border: none;
  outline: 0;
  background: none;
}
.cent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #777;
  font-size: 20px;
}

.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}

.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}

.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user_help_list.vue